var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { css as emotionCss, cx } from 'emotion';
import { getChildByType } from 'react-nanny';
import { useFlyout } from './private/context';
import { headerIcon } from '../styles/legacy';
import { Header, HeaderButtonContainer, HeaderText, HeaderTextWrapper, SubHeaderText } from './Flyout.styled';
import { BorderlessButton } from '@citrus/button';
import { Icon } from '@citrus/icon';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { isNotNilOrEmpty, isNilOrEmpty } from '@pcty/utils';
var VERSION = '5.5.1';
/** DISPLAY NAME: &lt;Flyout.Header&gt; */
var FlyoutHeader = function (_a) {
    var _b;
    var automationId = _a.automationId, css = _a.css, className = _a.className, classNameButtonContainer = _a.classNameButtonContainer, children = _a.children, _c = _a.showClose, showClose = _c === void 0 ? true : _c, title = _a.title, subtitle = _a.subtitle, _d = _a.__TYPE, TYPE = _d === void 0 ? 'FlyoutHeader' : _d;
    var citrus2022 = useTheme().citrus2022;
    var isCitron = citrus2022 !== null && citrus2022 !== void 0 ? citrus2022 : false;
    var debug = useCitrusDebug();
    var avatar = getChildByType(children, ['Avatar']);
    var flyout = useFlyout();
    var onClose = useCallback(function (e) { return flyout.onClose({ id: flyout.id, e: e }); }, [flyout]);
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b), className || '');
    if (isNilOrEmpty.all(title, avatar))
        return null;
    return (React.createElement(Header, __assign({ className: classes }, getAutomation(automationId), getDebug(debug, TYPE, VERSION)),
        React.createElement(HeaderTextWrapper, null, avatar ? (avatar) : (React.createElement(React.Fragment, null,
            React.createElement(HeaderText, null, title),
            isNotNilOrEmpty(subtitle) && React.createElement(SubHeaderText, null, subtitle)))),
        React.createElement(HeaderButtonContainer, { className: classNameButtonContainer }, showClose && (React.createElement(BorderlessButton, __assign({ onClick: onClose, size: isCitron ? 'medium' : 'small' }, getAutomation(flyout.id, 'close')),
            React.createElement(Icon, { bold: isCitron, className: emotionCss(headerIcon), "data-style": "headerIcon", name: "delete", title: flyout.lang.cancel }))))));
};
FlyoutHeader.defaultProps = {
    __TYPE: 'FlyoutHeader',
};
export default FlyoutHeader;
